export const environment = {
    production: true,
    apiUrl: {
        root: 'https://api.kuppel.co',
        admin: 'https://api.kuppel.co/admin',
        soporte: 'https://api.kuppel.co/support',
        app: 'https://api.kuppel.co/app',
    }
};